import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { ReactComponent as LogoImg } from '../../../assets/images/logo.svg'

export default function PrintPatientCard() {
  const data = localStorage.getItem('currentprintData')
  const parsedData = JSON.parse(data)

  const { doctor, full_name, dob, operationData } = parsedData || {}
  const { op_name, init_date, service_cost, patient_pay, paid_amount } = operationData || {}
  const { usedName, signature } = doctor || { usedName: 'Dr. No Name', signature: '' }

  const vendi = 'Gjakovë'

  // Utility to format any date as dd/MM/yyyy
  function formatEuropeanDate(date) {
    if (!date) return '-';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d)) return '-';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount) return '0 €';
    return `${Number(amount).toFixed(2)} €`;
  }

  const todayFormatted = formatEuropeanDate(new Date());
  const vitiLindjesFormatted = formatEuropeanDate(dob);
  const dataTerminitFormatted = formatEuropeanDate(init_date);

  useEffect(() => {
    window.print()
  }, [])

  return (
    <div className={styles.container}>
      <div id='a4_layout' className={styles.a4_layout}>
        <div className={styles.header_container}>
          <LogoImg style={{ height: 60 }} />
          <div>
            <h2 className={styles.web_logo}>Dental Med DIP SH.P.K.</h2>
            <h3 className={styles.web_logo} style={{ fontWeight: 400, fontSize: '1.1rem' }}>Raport Specialistk</h3>
          </div>
        </div>
        <div className={styles.patient_data_container}>
          <div className={styles.patient_data_row}>
            <span><b>Emri dhe mbiemri:</b> {full_name || '-'}</span>
            <span><b>Viti i lindjes:</b> {vitiLindjesFormatted}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Sherbimi:</b> {op_name || '-'}</span>
            <span><b>Data e terminit:</b> {dataTerminitFormatted}</span>
            <span><b>Vendi:</b> {vendi}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Ankesat Kryesore:</b> {operationData?.main_issue || '-'}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Komente:</b> {operationData?.feedback || '-'}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Egzaminimi:</b> {operationData?.examination || '-'}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Terapia dhe mindimi:</b> {operationData?.therapy || '-'}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Kostoja e sherbimit:</b> {formatCurrency(service_cost)}</span>
            <span><b>Pagesa e pacientit:</b> {formatCurrency(patient_pay || paid_amount)}</span>
          </div>
          <div className={styles.patient_data_row}>
            <span><b>Gjendja e pagesës:</b> {formatCurrency((patient_pay || paid_amount || 0) - (service_cost || 0))}</span>
          </div>
        </div>
        <div className={styles.footer_section}>
          <div className={styles.footer_left}>
            <div>Gjakovë: {todayFormatted}</div>
          </div>
          <div className={styles.footer_right}>
            <div className={styles.signature_label}>Mjeku:</div>
            <div className={styles.dr_name}>{usedName}</div>
            {signature && <img className={styles.img_signature} src={signature} alt='signature' />}
          </div>
        </div>
      </div>
    </div>
  )
}
